import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {SelectEventArgs} from "@syncfusion/ej2-angular-dropdowns";
import {DropDownButtonComponent, ItemModel, OpenCloseMenuEventArgs} from "@syncfusion/ej2-angular-splitbuttons";
import {InternationalizationService} from "../../services/internationalization/internationalization.service";

@Component({
  selector: 'sb-query-functions',
  templateUrl: './query-functions.component.html',
  styleUrls: ['./query-functions.component.scss']
})
export class QueryFunctionsComponent implements AfterViewInit {

  @ViewChild("button")
  button: DropDownButtonComponent;

  @Input()
  dataSource: any;

  @Input()
  callback: any;

  public items: ItemModel[] = [];

  constructor(private i18n: InternationalizationService) {}

  ngAfterViewInit() {
    this.button.items = this.dataSource.map((d, idx) => {
      return {
        id: idx,
        text: this.i18n.getMessage(d.i18nKey)
      }
    });
  }

  onSelect($event: SelectEventArgs) {
    const idx = $event.item.id;
    const data = this.dataSource[idx];
    this.callback(data);
  }

  onOpen($event: OpenCloseMenuEventArgs) {
    const buttonRect = this.button.element.getBoundingClientRect();
    const elementRect = $event.element.getBoundingClientRect();
    $event.element.parentElement.style.left = (buttonRect.left - elementRect.width + buttonRect.width) + "px";
  }
}
